<template>
  <div class="float-contact" :style="boxStyle">
    <el-card class="float-card" :body-style="{ padding: '2px 2px' }" shadow="always">
      <!-- 会展小智 -->
      <div class="fc-section" @click="openRouter">
        <img class="fc-qrcode" :src="huizhanQrcode" alt="会展小智" />
        <div class="fc-title">会展小智</div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'FloatContactQ',
  props: {
    huizhanQrcode: { type: String, required: true },
    // 位置/层级可调
    right: { type: [Number, String], default: 0 },
    top: { type: [Number, String], default: null },   // 设定 top 或 bottom 二选一
    bottom: { type: [Number, String], default: 120 },
    zIndex: { type: Number, default: 1000 },
    width: { type: [Number, String], default: 100 }
  },
  computed: {
    boxStyle () {
      const unit = v => (typeof v === 'number' ? `${v}px` : v);
      const style = {
        position: 'fixed',
        right: unit(this.right),
        zIndex: this.zIndex,
        width: unit(this.width)
      };
      if (this.top !== null) style.top = unit(this.top);
      else style.bottom = unit(this.bottom);
      return style;
    }
  },
  methods:{
    openRouter(){
      const { href } = this.$router.resolve({
        path: '/vannaai/home',
        query:{}
      });
      window.open(href, '_blank', 'noopener');
    },
  }
};
</script>

<style scoped>
.float-contact {
  display: grid;
  grid-auto-rows: min-content;
  gap: 10px;
  pointer-events: auto;
}
.float-card {
  padding: 0px 2px;
}
.fc-title {
  color: #666;
  font-size: 14px;
  margin-bottom: 6px;
}
.fc-phone {
  color: #409EFF; /* ElementUI 主色 */
  font-size: 16px;
  text-decoration: none;
}
.fc-qrcode {
  display: block;
  width: 100%;
  height: auto;
  /* 让二维码在卡片内留白 */
  padding-top: 2px;
}
@media (max-width: 768px) {
  /* 小屏默认隐藏，避免挡内容；需要可改成收起按钮 */
  .float-contact { display: none; }
}

.fc-section {
  text-align: center;
}

.fc-title {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
}

.fc-phone {
  font-size: 16px;
  font-weight: 500;
  color: #409EFF;
  text-decoration: none;
}

.fc-qrcode {
  width: 100%;
  max-width: 110px;
  margin: 0 auto;
  display: block;
}

.el-divider--horizontal {
  margin: 12px 0;
}
.fc-section:hover {
  background: #f7f9fc;
  border-radius: 4px;
}
.float-contact ::v-deep(.el-card__body){
  padding: 2px;
}
</style>
